<!-- src/App.vue -->

<template>
  <div id="app">
        <router-view></router-view>
  </div>
  <main>
    <ProfilePagePart1UserNamePFP :id="id"/>

  </main>
</template>


<script>
  import ProfilePagePart1UserNamePFP from '@/ProfilePagePart1UserNamePFP.vue';
  import 'animate.css';
  export default {
    name: 'ProfileMain',
    props: ['id'], // Add this to receive the id prop from router
    components: {
    //imageBlock,
    ProfilePagePart1UserNamePFP,
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      }
    },

  }

</script>